import { render, staticRenderFns } from "./ProductSearch.vue?vue&type=template&id=d4ba45ba&scoped=true&"
import script from "./ProductSearch.vue?vue&type=script&lang=js&"
export * from "./ProductSearch.vue?vue&type=script&lang=js&"
import style0 from "./ProductSearch.vue?vue&type=style&index=0&id=d4ba45ba&prod&lang=scss&"
import style1 from "./ProductSearch.vue?vue&type=style&index=1&id=d4ba45ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ba45ba",
  null
  
)

export default component.exports